//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _ from 'lodash';

const basePath = [
    'vehicles',
];

export const selectVehicles = (state) => {
    return _.get(state, [...basePath, 'vehicles'], []);
};

export const selectVehicleInEdit = (state) => {
    return _.get(state, [...basePath, 'vehicleInEdit']);
};

export default selectVehicles;
